import React, { forwardRef, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { AddressContext } from '../contexts/AddressContext';

const ParentData = forwardRef(({ formData, handleChange, onBlurValidate, errors, isEdit, isMunicipality }, ref) => {
    const { user } = useContext(AuthContext);
    const { parentEgnExist, parentData } = useContext(AddressContext)

    return (
        <>
            <div ref={ref} className="htext">Данни за родител/настойник</div>

            <div className="parent_data rounded p-3-mob">

                <div className="w-100 d-flex gap-3 flex-col-mob">

                    <div className="flex-col flex-wrap w-50 w-100-mob">
                        <div className="labels_rb" id="basic-addon1">
                            ЕГН*&nbsp;
                            <input
                                type="radio"
                                id="egnid"
                                name="parentIsEgn"
                                value="1"
                                checked={formData.parentIsEgn == '1'}
                                onChange={handleChange}
                                defaultChecked
                                disabled={isEdit || parentEgnExist || (parentData && parentData.egn)}
                            />
                            &nbsp;&nbsp;&nbsp;ЛНЧ*&nbsp;
                            <input
                                type="radio"
                                id="lncid"
                                name="parentIsEgn"
                                value="0"
                                checked={formData.parentIsEgn == '0'}
                                onChange={handleChange}
                                disabled={isEdit || parentEgnExist || (parentData && parentData.egn)}
                            />
                        </div>
                        <div className="labels_rb d-flex gap-2 flex-wrap w-100-mob" id="basic-addon1">
                            <input
                                type="text"
                                name="parentEgn"
                                className="form-control round_buttons"
                                placeholder={formData.parentIsEgn == 1 ? 'ЕГН на родител' : 'ЛНЧ на родител'}
                                value={formData.parentEgn}
                                onChange={handleChange}
                                onBlur={onBlurValidate}
                                disabled={isEdit || parentEgnExist || (parentData && parentData.egn)}
                            />
                            <label className="text-danger w-100 ">{errors.parentEgn && errors.parentEgn}</label>
                        </div>
                    </div>
                    <div className="w-50 w-100-mob">
                        <div className="labels_rb w-100" id="basic-addon1">Три имена*</div>
                        <input
                            type="text w-100"
                            name="parentName"
                            className="form-control round_buttons capital"
                            placeholder="Полето трябва да е изписано на кирилица"
                            value={formData.parentName}
                            onChange={handleChange}
                            disabled={isEdit || parentEgnExist || (parentData && parentData.egn)}
                            maxLength={100}
                            required
                        />
                    </div>


                </div>
                <div className="w-100 d-flex gap-3 mt-3 flex-col-mob">

                    <div className="flex-col flex-wrap w-50 w-100-mob">
                        <div className="labels_rb " id="basic-addon1"> Тел./мобилен номер за връзка* </div>
                        <input
                            type="text"
                            name="parentPhone"
                            className="form-control round_buttons"
                            value={formData.parentPhone}
                            onChange={handleChange}
                            disabled={parentEgnExist || (parentData && parentData.egn)}
                        />
                    </div>
                    <div className="flex-col flex-wrap w-50 w-100-mob">
                        <div className="labels_rb " id="basic-addon1"> Ел.поща* </div>
                        <input
                            type="email"
                            name="parentEmail"
                            className="form-control round_buttons"
                            value={formData.parentEmail}
                            onChange={handleChange}
                            onBlur={onBlurValidate}
                            disabled={parentEgnExist || (parentData && parentData.egn)}
                        />
                        <label className="text-danger w-100 ">{errors.parentEmail && errors.parentEmail}</label>
                    </div>

                </div>
            </div>
        </>
    );
})

export default ParentData;